<template>
    <div class="cobalt-task-form">
        <div class="container p-0 mt-1 mb-4">
            <div class="row">
                <div class="col-lg-12 d-flex flex-column">
                    <div class="np-group justify-content-between pb-2">
                        <div class="np-group">
                            <div class="np-group flex-grow-1">        
                                <IndicatorDaysTo  
                                    :dateStart="taskData.date_planned_start"
                                    :dateEnd="taskData.date_planned_end"
                                    classes="np-badge np-borderless np-font-xs me-2"
                                    background=""
                                    v-if="!taskData.date_actual_end" 
                                />  
                            </div>                                                    
                            <div class="np-badge np-inactive np-font-xs me-2">
                                {{ $t("UI.task.taskCreatedAt") }} {{ localeDateTime(taskData.date_create) }}
                            </div>                        
                            <div class="np-badge np-inactive np-font-xs">
                                {{ $t("UI.task.taskUpdatedAt") }} {{ localeDateTime(taskData.date_update) }}
                            </div>
                        </div>
                    </div>
                    <textarea class="form-control np-textarea has-text-weight-bold flex-grow-1" id="taskTitle" autocomplete="off" 
                        v-model="taskData.title" :placeholder="$t('UI.task.name')"></textarea>                       
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-lg-12">
                    <textarea class="form-control np-textarea np-font-m" id="taskDescription" autocomplete="off" 
                        v-model="taskData.description" :placeholder="$t('UI.task.description')"></textarea>                    
                </div>
            </div>
        </div>

        <div class="mb-2">
            <ul class="nav nav-pills np-tabs np-nowrap" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="np-tab np-nowrap w-100" :class="{ active: activeTab == 'params' }" @click="setActiveTab('params')" id="files-tab" data-bs-toggle="tab" data-bs-target="#params" type="button" role="tab" aria-controls="home" aria-selected="true">
                        <svg class="icon"><use href="@/assets/images/icons/file-doc.svg#icon"></use></svg>
                        {{ $t("UI.task.params") }}
                    </button>
                </li>

                <!--
                <li class="nav-item" role="presentation">
                    <button class="np-tab np-nowrap" :class="{ active: activeTab == 'budget' }" @click="setActiveTab('budget')" id="budget-tab" data-bs-toggle="tab" data-bs-target="#budget" type="button" role="tab" aria-controls="home" aria-selected="true">
                        <svg class="icon"><use href="@/assets/images/icons/wallet.svg#icon"></use></svg>
                        {{ $t("UI.task.budget") }}
                        <span v-if="this.taskData.files.length > 0" class="np-badge-s np-inactive ms-1">{{ this.taskData.files.length }}</span>
                    </button>
                </li>
                --> 

                <li class="nav-item" role="presentation">
                    <button class="np-tab np-nowrap w-100" :class="{ active: activeTab == 'files' }" @click="setActiveTab('files')" id="files-tab" data-bs-toggle="tab" data-bs-target="#files" type="button" role="tab" aria-controls="home" aria-selected="true">
                        <svg class="icon"><use href="@/assets/images/icons/folder2.svg#icon"></use></svg>
                        {{ $t("UI.task.files") }}
                        <span v-if="this.taskData.files.length > 0" class="np-badge-s np-inactive ms-1">{{ this.taskData.files.length }}</span>
                    </button>
                </li>

                <li class="nav-item" role="presentation">
                    <button class="np-tab np-nowrap w-100" :class="{ active: activeTab == 'comments' }" @click="setActiveTab('comments')" id="comments-tab" data-bs-toggle="tab" data-bs-target="#comments" type="button" role="tab" aria-controls="home" aria-selected="true">
                        <svg class="icon"><use href="@/assets/images/icons/comment.svg#icon"></use></svg>
                        {{ $t("UI.task.comments") }}
                        <span v-if="this.taskData.comments?.length > 0" class="np-badge-s np-inactive ms-1">{{ this.taskData.comments.length }}</span>
                    </button>
                </li>                
            </ul>
        </div>       

        <div class="position-relative flex-grow-1">
            <div class="tab-content cobalt-task__tab-content" id="myTabContent">
                <div class="tab-pane fade show" :class="{ active: activeTab === 'params' }" id="params" role="tabpanel" aria-labelledby="params-tab">
                        <div class="np-form-group justify-content-between p-4 mb-4">
                            <!--
                            <div class="d-flex flex-column pe-4">
                                <div class="np-font-m np-f-medium mb-2">Выполнено</div>
                                <div class="np-badge np-success np-borderless p-2">
                                    <span class="np-font-m">78%</span>
                                </div>  
                            </div>
                            -->
                            <div class="d-flex flex-column pe-4">
                                <div class="np-font-m np-f-medium mb-2">{{ $t("UI.task.priority") }}</div>
                                    <Multiselect 
                                    class="np-priority-select"
                                    v-model="selectedPriority" 
                                    :placeholder="this.$t('UI.select')"
                                    selectLabel=""
                                    :options="priorityValues" 
                                    :searchable="false"
                                    track-by="value"
                                    label="label"
                                    selectedLabel=""
                                    deselectLabel=""
                                    >
                                        <template #singleLabel="props">
                                            <span class="np-badge np-borderless p-2" :class="props.option.class">
                                                {{ $t(props.option.label) }}
                                            </span>                                    
                                        </template>
                                        <template #option="props">
                                            <span class="np-badge np-borderless p-2" :class="props.option.class">
                                                {{ $t(props.option.label) }}
                                            </span>
                                        </template>
                                    </Multiselect> 
                            </div>
                            <div class="d-flex flex-column px-4">
                                <div class="np-font-m np-f-medium mb-2">{{ $t("UI.task.date") }}</div>

                                <flat-pickr 
                                    mode="single"
                                    v-model="datePlannedStart"
                                    :placeholder="this.$t('UI.selectDate')"
                                    :config="{
                                        enableTime: true,
                                        dateFormat: 'U',
                                        altInput: true,
                                        altFormat: 'd.m.Y H:i',
                                        time_24hr: true,
                                        onChange: function(selectedDates, dateStr, instance) {
                                            instance.close()
                                        }
                                    }"
                                >
                                </flat-pickr>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="np-font-m np-f-medium mb-2">{{ $t("UI.task.deadline") }}</div>

                                <flat-pickr 
                                    mode="single"
                                    v-model="datePlannedEnd"
                                    :placeholder="this.$t('UI.selectDate')"
                                    :config="{
                                        enableTime: true,
                                        dateFormat: 'U',
                                        altInput: true,
                                        altFormat: 'd.m.Y H:i',
                                        time_24hr: true,
                                        minDate: disabledBeforeStartTime,
                                        onChange: function(selectedDates, dateStr, instance) {
                                            instance.close()
                                        }
                                    }"
                                >
                                </flat-pickr>
                            </div>                                                         
                        </div>

                        <div class="np-form-group justify-content-between p-4 mb-4">
                            <div class="d-flex flex-column align-items-start pe-4">
                                <div class="np-font-ml np-f-medium mb-2">{{ $t("UI.task.author") }}</div>
                                <div class="np-group pt-1">
                                    <CobaltProfile :firstName="taskData.author?.first_name" :lastName="taskData.author?.last_name" />  
                                    <svg class="ms-2"><use href="@/assets/images/icons/eye.svg#icon"></use></svg>
                                </div>
                            </div>

                            <div class="d-flex flex-column align-items-start pe-4">
                                <div class="np-font-ml np-f-medium mb-2">{{ $t("UI.task.inspector") }}</div>
                                <Multiselect 
                                    v-model="selectedPerformers" 
                                    :placeholder="this.$t('UI.select')"
                                    :multiple="true"
                                    :options="projectUsers" 
                                    :class="['cobalt-task__multiselect']"
                                    track-by="id"                              
                                    selectLabel=""
                                    label="first_name"
                                    selectedLabel=""
                                    deselectLabel="&#x2715;"
                                    open-direction="bottom"
                                    @remove="removePerformer"
                                >
                                    <template #selection="{ values, search, isOpen }">
                                        <div class="multiselect__single cobalt-profile-list__wrapper" v-show="!isOpen">
                                            <div class="cobalt-profile-list__item" v-for="item in values">
                                                <CobaltProfile 
                                                    :firstName="item.first_name" 
                                                    :lastName="item.last_name" 
                                                    :short="values.length > 1 ? true : false"
                                                />
                                            </div>
                                        </div>
                                    </template>                            
                                    <template #option="props">
                                        <span class="np-font-s">
                                            {{ props.option.first_name + ' ' + props.option.last_name }}
                                        </span>
                                    </template>
                                </Multiselect>                                  
                            </div>  
                            
                            <div class="d-flex flex-column align-items-start pe-4">
                                <div class="np-font-ml np-f-medium mb-2">{{ $t("UI.task.performers") }}</div>
                                <Multiselect 
                                    v-model="selectedPerformers" 
                                    :placeholder="this.$t('UI.select')"
                                    :multiple="true"
                                    :options="projectUsers" 
                                    :class="['cobalt-task__multiselect']"
                                    track-by="id"                              
                                    selectLabel=""
                                    label="first_name"
                                    selectedLabel=""
                                    deselectLabel="&#x2715;"
                                    open-direction="bottom"
                                    @remove="removePerformer"
                                >
                                    <template #selection="{ values, search, isOpen }">
                                        <div class="multiselect__single cobalt-profile-list__wrapper" v-show="!isOpen">
                                            <div class="cobalt-profile-list__item" v-for="item in values">
                                                <CobaltProfile 
                                                    :firstName="item.first_name" 
                                                    :lastName="item.last_name" 
                                                    :short="true"
                                                />
                                            </div>
                                        </div>
                                    </template>                            
                                    <template #option="props">
                                        <span class="np-font-s">
                                            {{ props.option.first_name + ' ' + props.option.last_name }}
                                        </span>
                                    </template>
                                </Multiselect>    
                            </div>                              
                        </div>
                               
                        <div class="np-form-group justify-content-between p-4 mb-4">
                            <div class="row mb-4 align-items-start flex-grow-1" v-if="taskData.id">
                                <div class="np-group np-font-ml np-f-medium flex-grow-1 mb-3">
                                    {{ $t("UI.task.tags") }}
                                </div>

                                <div class="np-group selected-tags np-flex-wrap mb-3">
                                    <span v-for="(tag, index) in this.selectedTags" :key="index" class="np-badge-s np-gray np-font-s mt-1 me-1">
                                        {{ tag }}
                                        <button @click="doRemoveTag(tag)" class="np-borderless np-transparent ms-2">
                                            ✕ 
                                        </button>
                                    </span>
                                </div>
                                
                                <span class="cobalt-task-form__plaintext">
                                    <multiselect 
                                        v-model="taskData.tags" 
                                        tag-placeholder="" 
                                        :placeholder="$t('UI.task.searchOrAddTag')"
                                        selectLabel=""
                                        deselectLabel="✖"
                                        :options="this.tags" 
                                        :showNoOptions="false"
                                        :showNoResults="false"
                                        :multiple="true" 
                                        :taggable="true" 
                                        :hide-selected="true"
                                        :loading="this.isTagsLoading"
                                        :block-keys="['Tab', 'Enter', '']"
                                        @search-change="this.doSearchTags"
                                        @select="this.doAddTag"
                                        @tag="this.doAddTag">

                                        <template #tag="{ option, remove }">
                                            
                                        </template>
                                        <template #clear="props">
                                            <div class="multiselect__clear" v-if="taskData.tags?.length"
                                                @mousedown.prevent.stop="clearAll(props.search)">{{ props.option }}</div>
                                        </template>    
                                        <template #noOptions>
                                            <span>{{ $t("UI.nothingFound") }}</span>
                                        </template>                                                          
                                        <template #noResult>
                                            <span>Oops! No elements found. Consider changing the search query.</span>
                                        </template>

                                    </multiselect>
                                </span>
                            </div> 
                        </div>
                    </div>

                <div class="tab-pane fade show" :class="{ active: activeTab === 'files' }" id="st-files" role="tabpanel" aria-labelledby="st-files-tab">
                    <div class="flex flex-wrap cobalt-uploader">
                        <uploader
                            ref="uploaderRef"
                            :auto="false"
                            @file-added="onFilesAdded"
                            @file-error="onFilesError"
                        >
                            <uploader-drop>
                                <span>{{ $t("UI.task.dropOrSelectFiles") }}</span>
                                <uploader-btn>{{ $t("UI.task.selectFiles") }}</uploader-btn>
                            </uploader-drop>
                            <uploader-list></uploader-list>                                    
                        </uploader>
                        
                        <div class="uploader-list">
                            <div class="uploader-file" v-for="file in taskData.files" :key="file.id">
                                <div class="uploader-file-name" @click="callViewer(file.id, taskData.files)"><i class="uploader-file-icon" icon="unknown"></i>{{ file.name }}</div>
                                <div class="uploader-file-actions">
                                    <div class="uploader-file-size">
                                        {{ formatBytes(file.fileSize) }}
                                    </div>                                    
                                    <div class="uploader-file-actions">
                                        <a class="btn btn-base me-1" target="_blank" :download="file.filePath" :href="Config.SERVER + 'web/' + file.filePath">
                                            <img src="@/assets/images/dashboard/base-download-dark.svg">
                                        </a>
                                        <div class="devider">|</div>
                                        <button class="btn btn-base btn-warning me-1" @click="onFileDelete(file.id)">
                                            <img src="@/assets/images/dashboard/task-remove.svg">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade show h-100" :class="{ active: activeTab === 'comments' }" id="comments" role="tabpanel" aria-labelledby="comments-tab">
                    <div class="np-group np-group-column h-100">
                        <Comments 
                            :comments="taskData.comments"
                            :taskId="taskData.id"
                            :isSubtask="true"
                            :activeUserId="this.activeUser?.id"
                            @refresh="refreshParent">
                        </Comments>
                    </div>
                </div>
            </div>
        </div>                       
        <!-- 
        <div v-if="datUpdateStatus.errorText != ''">
            <p class="mt-2 mb-0 text-danger">{{ datUpdateStatus.errorText }}</p>
        </div>
        -->
    </div>
</template>

<script>
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import CobaltPerformer from "@/components/dashboard/parts/CobaltPerformer.vue"
import CobaltProfilesList from "@/components/dashboard/parts/CobaltProfilesList.vue"
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Russian } from "flatpickr/dist/l10n/ru.js"

import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import Multiselect from 'vue-multiselect'
import { ref } from 'vue'
import { VueDraggable } from 'vue-draggable-plus'
import { mapGetters, mapActions } from 'vuex'
import { createToast } from 'mosha-vue-toastify'  
import { localeDate, localeTime, localeDateTime, formatBytes, eventDate, priorityValues } from '@/utils/format'
import Config from '../../../config.js'
import Comments from "@/components/elements/Comments.vue"

export default {
    components: {
        DatePicker,
        Multiselect,
        CobaltProfile,
        CobaltPerformer,
        CobaltProfilesList,
        IndicatorDaysTo,
        flatPickr,
        Comments
    },    
    props: {
        activeUser: {
            type: Object,
            required: true
        },        
        taskData: {
            type: Object,
            required: true
        },
        projectUsers: {
            type: Array,
            required: true
        },
        colors: {
            type: Array,
            required: true
        },   
        parentId: {
            type: Number,
            required: true
        },
        projectInfo: {
            type: Object,
            required: true
        }          
    },    
    data() {
        return {
            Config,
            activeTab: 'params',
            files: [],
            tags: [],
            priorityValues,
            isTagsLoading: false
        }
    },
    computed: {
        datePlannedStart: {
            get() {
                return this.taskData.date_planned_start ? this.taskData.date_planned_start + "" : null
            },
            set(option) {
                this.taskData.date_planned_start = option ? parseInt(option) : null
            }
        },
        datePlannedEnd: {
            get() {
                return this.taskData.date_planned_end ? this.taskData.date_planned_end + "": null
            },
            set(option) {
                this.taskData.date_planned_end = option ? parseInt(option) : null
            }
        },     
        disabledBeforeStartTime: {
            get() {
                return this.taskData.date_planned_start ? new Date(this.taskData.date_planned_start * 1000) : null
            }
        },                   
        selectedPriority: {
            get() {
                return this.priorityValues.find(option => option.value === this.taskData.priority) || null
            },
            set(option) {
                this.taskData.priority = option ? option.value : null
            }
        },
        selectedPerformers: {
            get() {
                return this.taskData.performer
            },
            set(option) {
                if (Array.isArray(option) && option.length > 0) {
                    const updatedPerformers = [...option]
                    this.taskData.performer = updatedPerformers
                    this.updateTaskPerformer(true, true, option[option.length - 1])
                }
            }            
        },
        selectedTags: {
            get() {
                return this.taskData.tags
            },
            set(option) {
                if (Array.isArray(option) && option.length > 0) {
                    const updatedTags = [...option]
                    this.taskData.tags = updatedTags
                }
            }   
        }       
    },
  
    methods: {
        ...mapActions('board', ['updatSubTsk', 'updatSubTskDate', 'clearSubTskDate', 'listPerformers', 'assignPerformer', 'detachPerformer', 'listControllers', 'assignController', 'detachController', 'uploadSubFiles', 'deleteSubFile', 'addTaskComment', 'searchTags', 'addTag', 'removeTag', 'completeSubTask']),
        localeDate,
        localeTime,
        localeDateTime,
        formatBytes,
        initialize() {
            this.activeTab = 'params'
            this.replyToComment = null
            this.$refs.uploaderRef.fileList = []
        },
        disabledBeforeStart(date) {
            const start = new Date(this.taskData.date_planned_start * 1000);
            return date < start;
        },           
        chColorTsk(val) {
            this.taskData.color = val
        },         
        async updateSubTask() {
            let updateResult = await this.updatSubTsk(this.taskData)

            if (updateResult) {
                this.taskData.id = updateResult.id       
            }

            return updateResult
        },
        async updateTaskPerformer(operation, subtask, performer) {
            if (operation) {
                await this.assignPerformer({
                    task_id: this.taskData.id,
                    subtask: subtask,
                    performer_id: performer.id,
                })
            } else {
                await this.detachPerformer({
                    task_id: this.taskData.id,
                    subtask: subtask,
                    performer_id: performer.id,
                })                
            }
        },
        removePerformer(option, id) {
            const updatedPerformers = this.taskData.performer.filter(item => item.id !== option.id)
            this.taskData.performer = updatedPerformers
            this.updateTaskPerformer(false, true, option)
        },        
        async updateTaskDate() {
            if (!this.taskData.id) {
                await this.updateSubTask();
            }

            try {
                await this.updatSubTskDate(this.taskData)
            }  catch (error) {
                console.log(error.response)
                return null
            }
        },
        async clearTaskDate() {
            if (this.taskData && this.taskData.id)
                await this.clearSubTskDate(this.taskData)
        },   
        onFilesAdded(files) {
            this.files = this.files.concat(files);
            this.doUploadFiles();
        },  
        onFileDelete(id) {
            this.doDeleteFile(id)

            this.taskData.files = this.taskData.files.filter(function( obj ) {
                return obj.id !== id;
            });            

            this.refreshParent()
        },  
        async doDeleteFile(id) {
            try {
                const response = this.deleteSubFile(id)

                if (response) {
                    console.log('File remove successfully:', response);
                } else {
                    console.error('File remove failed:', response);
                }
            } catch (error) {
                console.error('Error removing files:', error);
            }
        },         
        async doUploadFiles() {
            if (this.files.length === 0) {
                console.log('No files to upload.');
                return;
            }

            const formData = new FormData();

            this.files.forEach((file, index) => {
                formData.append(`files[${index}]`, file.file);
            });

            formData.append('id', this.taskData.id);

            try {
                const response = this.uploadSubFiles(formData)

                if (response) {
                    console.log('Files uploaded successfully:', response);
                } else {
                    console.error('File upload failed:', response);
                }
            } catch (error) {
                console.error('Error uploading files:', error);
            }

            this.files = [];
        },    
        async updateTaskTags() {

        },
        async doSearchTags(search) {   
            if (!search) return

            this.isLoading = true
            const searchData = {
                name: search,
                projectId: this.projectInfo.id
            }        
            let response = await this.searchTags(searchData)
            this.isTagsLoading = false
            this.tags = response ? response : []
        }, 
        async doSelectTag(tag) {
            this.tags.push(tag)
            this.taskData.tags = this.tags;            
        },
        async doAddTag(tag) {
            this.isLoading = true
            const tagData = {
                name: tag,
                task_id: this.taskData.id,
                isSubtask: true
            }

            let newTags = await this.addTag(tagData)
            if (newTags) 
                this.tags = newTags
            else    
                createToast({ description: this.$t("message.errorSavingTask") }, Config.TOAST_CONFIG_ERROR) 

            this.isTagsLoading = false

            this.taskData.tags = this.tags;
        },     
        async doRemoveTag(tag) {
            this.isLoading = true
            const tagData = {
                name: tag,
                task_id: this.taskData.id,
                isSubtask: false
            }
            this.tags = await this.removeTag(tagData)
            this.isTagsLoading = false

            this.taskData.tags = this.tags;
        },
        onFilesError(file, error) {
            console.error('File upload failed:', file, error);
        }, 
        setActiveTab(tab) {
          this.activeTab = tab
        },
        async complete(_complete) {
            const res = await this.completeSubTask( { complete: !_complete, id: this.taskData.id } )

            // REFACTORING NEEDED
            if (res) this.taskData.date_actual_end = !_complete

            this.refreshParent()
        },    
        refreshParent() {
            this.$emit('refreshForm')
        },         
        callViewer(id, files) {
            this.$emit('callViewer', id, files)
        }                               
    }
}
</script>

<style></style>